import { useState, useEffect } from 'react';
import styled from '@emotion/styled';
import { Card, CardContent, Divider, CardHeader, CardActions, Button, useTheme } from '@mui/material';

import { CardBlock, CardBlockHeader, CardBlockContainer, CardSpacer } from '../../../utils/utilities/CardComponents';

import { useFormikContext } from 'formik';

import { useFormData } from '../../../contexts/FormData';

import { useQuery } from '@tanstack/react-query';

import { BasicFlex, InputLabel } from '../../../utils/Common';

import { getRepairFollowUps } from '../apiService';

import TaskAltRoundedIcon from '@mui/icons-material/TaskAltRounded';

import { getTicketEta } from '../../Repair_Tickets/helpers';

import useFollowUpSnackbarStore from '../../../store/repair_follow_up';

const FollowUpList = styled(BasicFlex)`
  overflow-x: auto;
  width: auto;
  padding-bottom: 1rem;
`

const RepairCard = ({repair}) => {

  const { values, setFieldValue } = useFormikContext() || {};

  let findRepair = values?.services?.find(service => service.repair_ticket_id === repair.repair_ticket_id);

  let selected = !!findRepair;

  const hideSnackbar = useFollowUpSnackbarStore(state => state.hideSnackbar);

  const selectRepair = () => {
    let services = values?.services || [];
    let newServices = services.filter(service => service.name);
    let newService = {
      stylist_id: values.stylist_id,
      name: repair.follow_up_service,
      repair_ticket_id: repair.repair_ticket_id,
      wig_id: repair.wig_id,
      wig_source: repair.wig_source,
    };
    newServices.push(newService);
    setFieldValue("services", newServices);
    hideSnackbar();
  }

  const theme = useTheme();

  let follow_up = [
    {
      header: "Created On",
      info: repair?.created_at
    },
    {
      header: "Follow-Up Service",
      info: repair?.follow_up_service
    },
    {
      header: "Scheduled ETA",
      info: getTicketEta(repair)
    }
  ]
  return (
    <Card variant='outlined' sx={{backgroundColor: selected ?  theme.palette.success.faint : "", borderColor: selected ? theme.palette.success.main : "", minWidth: "fit-content"}}>
      <CardHeader title={repair.wig_id} subheader={repair.wig_sku} sx={{p: 2, px: 2}}
      action={ selected &&
        <TaskAltRoundedIcon fontSize="small" color="success" sx={{mr: ".5rem", mt: "0"}} />
      }
        slotProps={{title: {sx: {fontSize: "1.4rem"}}, subheader: {sx: {fontSize: "1.2rem"}}}}
      />
      <CardContent sx={{p: 2, pt: 0, pb: "1rem !important"}}>
        <CardBlockContainer $gap="1rem">
          {follow_up.map((item, index) => <CardBlock key={index} header={item.header} info={item.info} />)}
        </CardBlockContainer>
      </CardContent>
      <Divider />

      <CardActions sx={{justifyContent: "flex-end"}}>
        <Button size="small" variant="contained" disabled={selected} onClick={selectRepair}>Select</Button>
      </CardActions>
    </Card>
  )
}

const FollowUps = () => {
  const { values, setFieldValue } = useFormikContext() || {};
  const { formValues } = useFormData() || {};

  let customer_id = values?.customer_id

  const { data: repairs } = useQuery({
    queryKey: ["repair_tickets", "follow_ups", customer_id],
    queryFn: () => getRepairFollowUps(customer_id),
    enabled: !!values?.customer_id
  })

  return (
    <>
      <InputLabel>Repair Follow Ups</InputLabel>
      <FollowUpList justify="flex-start" gap="1.5rem">
        {repairs?.map((repair, index) => <RepairCard repair={repair} key={index} />)}
      </FollowUpList>
    </>
  )

};

export default FollowUps;